import { i as e } from "../_plugin-vue_export-helper-CTQVpqU-.js";
import { t } from "../i18n-lite-BcmwMblk.js";
import { a as n, c as r, i, n as a, o, r as s, s as c, t as l } from "../nl-De_DKoGY.js";
import { t as u } from "../PixMailMessage.ce-CiBuIIar.js";
//#region src/webcomponents/pix-mail-message/pix-mail-message.ce.js
t.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": r,
	"./locales/en.json": c,
	"./locales/es-419.json": o,
	"./locales/es.json": n,
	"./locales/fr-BE.json": i,
	"./locales/fr.json": s,
	"./locales/it.json": a,
	"./locales/nl.json": l
}));
var d = e(u, { configureApp(e) {
	t.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(t);
} });
window.customElements.define("pix-mail-message", d);
//#endregion
